"use strict";
/*- IIFE function for instant revoke -*/
(function () {
    var Box_Builder = {
        _selectors: {
            addToBundle: ".js-add-to-mini",
            productItem: ".js-product-grid",
            removeItemFromBundle: ".js-remove-item:not(.evt-bind)",
            qtySelector: ".qty-options__item input",
            addBundleToCart: "#addToCart",
            addToCart: ".js-add-to-cart",
            backOneStep: ".js-backstab",
            priceSelector: ".js-price",
            compareAtPriceSelector: ".js-price-compare",
            miniCartItems: ".js-mini-cart-items"
        },

        _bundleVariables: {
            allProductsArray: [],
            maxPerRow: 0,
            energyInitalPrice: 0,
            currentQty: document.querySelector('input[checked]').value
        },

        _init: function () {
            this._initalizeVariables();
            this._bindEvents();
            this._swapStepTitle();
            this._openInfoDialog();
            this._stickyNav();
            this._getQtyToUnlockStepOne();
        },

        _openInfoDialog() {
            const btn = document.querySelector('.info-icon');
            const container = document.querySelector('.ed-info-content-container');
            if (btn) {
                btn.addEventListener('click', function () {
                    container.style.opacity = container.style.opacity === '1' ? '0' : '1';
                })
            }
        },

        _stickyNav: function () {
            if (window.innerWidth < 1000) {
                document.addEventListener('DOMContentLoaded', () => {
                    let lastScrollTop = 0;
                    const container = document.querySelector('.bundle_sticky-container');
                    const elem = container.querySelector('.bundle_sticky-wrapper');
                    const elemH = elem.clientHeight;
                    container.style.height = elemH + 'px';

                    const anouncementBar = document.getElementById('shopify-section-announcement-bar');
                    const header = document.getElementById('shopify-section-header');

                    let isSticky = false;

                    window.addEventListener('scroll', function () {
                        if (elem) {
                            const rect = elem.getBoundingClientRect();
                            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

                            if (!isSticky && rect.top <= 0 && currentScrollTop > lastScrollTop) {
                                elem.classList.add('sticky');
                                anouncementBar.style.display = 'none'
                                header.style.display = 'none'
                                setTimeout(() => {
                                    isSticky = true;
                                }, 400);
                            } else if (isSticky && currentScrollTop < lastScrollTop) {
                                elem.classList.add('sticky-fade-out');
                                anouncementBar.style.display = 'block'
                                header.style.display = 'block'
                                setTimeout(() => {
                                    elem.classList.remove('sticky', 'sticky-fade-out');
                                    isSticky = false;
                                }, 400);
                            }

                            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
                        }
                    });
                });
            }
        },

        _getBtnText() {
            const activeStep = this._getCollectionIDs().dataStep;
            const bundleItems = document.querySelectorAll('.bundle_steps-item');
            const enable_singles = this._bundleVariables.enable_singles;
            const text_continue = this._bundleVariables.text_continue;
            const text_checkout = this._bundleVariables.text_checkout;
            let buttonTexts = [];
            let selectedStep = bundleItems[1];
            const activeInput = this._getActiveValue();
            const max_steps = this._maxSteps;


            if (activeStep === '2' && activeInput > 0) {
                selectedStep = bundleItems[2];
            }

            const buttons = selectedStep.querySelectorAll('.bundle-nav__item-btn');
            buttons.forEach(btn => {
                const buttonText = btn.textContent.trim()
                buttonTexts.push(buttonText);
            })

            let text;

            if (activeStep === '1' || activeStep === '2' && activeInput > 0) {
                const buttonNames = buttonTexts.join(", ")
                text = text_continue + ' ' + buttonNames;

                if (activeStep === max_steps) {
                    text = text_checkout;
                }

                if (enable_singles) {
                    text = text_checkout;
                }
            } else {
                text = text_checkout;
            }

            return text;
        },

        _setBtnText() {
            const text = this._getBtnText();
            const addToCartText = document.querySelector(".add-to-cart-text");
            addToCartText.textContent = text;
        },

        _atcPriceInit: function () {
            let _this = this;
            this._setBtnText();
            const qtyChecked = document.querySelector(this._selectors.qtySelector + ':checked');
            const priceWrapper = document.querySelectorAll(this._selectors.priceSelector);
            var price = qtyChecked.dataset.price;
            priceWrapper.forEach(function (element) {
                element.innerHTML = _this._formatMoney(price, window.theme.strings.money_format_with_code_preference);
            });
        },


        // Enables ATC Button when the box is filled

        _updateAtcDisabling() {
            const atcList = document.querySelectorAll(this._selectors.addToCart);
            const activeStep = parseInt(this._getCollectionIDs().dataStep);
            const collectionIDs = this._getCollectionIDs().collectionIDs;
            const numberOfMatches = this._getMinicartItemCol(collectionIDs);
            const qtyToUnlock = this._getQtyToUnlockStepOne();
            const activeInput = this._getActiveValue();
            const enable_singles = this._bundleVariables.enable_singles;
            const max_steps = this._maxSteps;

            let activateBtn = true;

            if (activeStep === 1 && numberOfMatches == qtyToUnlock || activeStep > 1 && numberOfMatches === 1) {
                activateBtn = false;
            }

            let lastStep = false;

            if (activeStep === '2' && activeInput > 0 ) {
                lastStep = true;
            } else if (activeInput === 0 && activeStep === 2) {
                lastStep = true;
            } else if (max_steps === activeStep) {
                lastStep = true;
            } else {
                lastStep = false;
            }

            if (enable_singles) {
                lastStep = true;
            }

            atcList.forEach((atc) => {
                if (lastStep) {
                    atc.setAttribute('last-step', true)
                } else (
                    atc.setAttribute('last-step', false)
                )
                atc.dataset.disabled = activateBtn;
            });
        },

        _initalizeVariables: function () {
            let _this = this;
            let variableJSON = JSON.parse(document.querySelector("#mixnmatchVariables").innerHTML);
            this._bundleVariables.maxPerRow = variableJSON.max_per_row;
            this._bundleVariables.discountRules = variableJSON.discount_rules;
            this._bundleVariables.qtyToUnlockAtc = variableJSON.qty_to_unlock_atc;
            this._bundleVariables.enable_foodkur = variableJSON.enable_foodkur;
            this._bundleVariables.enable_singles = variableJSON.enable_singles;
            this._bundleVariables.hash = variableJSON.hash;
            this._bundleVariables.prices = variableJSON.prices;
            this._bundleVariables.prices = variableJSON.prices;
            this._bundleVariables.text_continue = variableJSON.text_continue;
            this._bundleVariables.text_checkout = variableJSON.text_checkout;
            this._bundleVariables.free_gifts = variableJSON.free_gifts;

            this._maxSteps = document.querySelector('.bundle_steps-row').getAttribute('maxSteps');

            this._bundleVariables.discountLimiter = [];
            for (let _limit in variableJSON.discount_rules) {
                this._bundleVariables.discountLimiter.push(parseInt(_limit));
            }
            this._bundleVariables.translations = window.mixnmatch.strings;
            var jsAccordion = document.querySelector(".js-accordion[data-slider='products']");
            if (jsAccordion) {
                this._bundleVariables.energyInitalPrice = JSON.parse(jsAccordion.querySelector(_this._selectors.productItem).querySelector("script").innerHTML).raw_price;
            }
            this._atcPriceInit();
            this._updateAtcDisabling();
        },

        _bindEvents: function () {
            let _this = this;
            const addToBundleButtons = document.querySelectorAll(this._selectors.addToBundle);
            const addToCartButtons = document.querySelectorAll(this._selectors.addToCart);
            const qtyInputs = document.querySelectorAll(this._selectors.qtySelector);
            const priceWrapper = document.querySelectorAll(this._selectors.priceSelector);
            const backOneStep = document.querySelectorAll(this._selectors.backOneStep);

            if (addToBundleButtons && addToBundleButtons.length > 0) {
                addToBundleButtons.forEach(function (addToBundleBtn) {
                    addToBundleBtn.addEventListener("click", _this._handleAddToBundleEvent.bind(this), true);
                });
            }

            if (addToCartButtons && addToCartButtons.length > 0) {
                addToCartButtons.forEach((addToCartBtn) => {
                    addToCartBtn.addEventListener('click', () => {
                        const collectionIDs = this._getCollectionIDs().collectionIDs;
                        const activeStep = this._getCollectionIDs().dataStep;
                        const qtyToUnlock = this._getQtyToUnlockStepOne();
                        const numberOfMatches = this._getMinicartItemCol(collectionIDs);

                        let activateBtn = false;

                        if (activeStep == 1 && numberOfMatches == qtyToUnlock || activeStep > 1 && numberOfMatches == 1) {
                            activateBtn = true;
                        }

                        if (activateBtn) {
                            const btnText = this._getBtnText();
                            if (btnText != this._bundleVariables.text_checkout) {
                                const activeStepValue = parseInt(this._getCollectionIDs().dataStep) + 1;
                                document.querySelector(`.bundle_steps-item[data-step='${activeStepValue}'] h2`).click();

                                if (activeStepValue > 1) {
                                    document.querySelector('.js-backstab').classList.remove("hidden");
                                }

                                const atcList = document.querySelectorAll(this._selectors.addToCart);
                                atcList.forEach((atc) => {
                                    atc.dataset.disabled = true;
                                });

                                const disable = false;
                                this._lockProducts(disable);
                            } else {
                                this._handleAddToCartEvent(this);
                            }
                        }

                        this._miniCartItemStep();
                        this._updateAtcDisabling();
                        this._miniCartItemStep();
                        this._scrollTop();
                    });
                });
            }

            if (qtyInputs && qtyInputs.length > 0) {
                const enable_singles = this._bundleVariables.enable_singles;

                qtyInputs.forEach(function (input) {
                    input.addEventListener('change', function () {
                        let clearCart = true;
                        if (input.value > _this._bundleVariables.currentQty) {
                            clearCart = false;
                        }

                        _this._bundleVariables.currentQty = input.value;
                        const stepsRow = document.querySelector('.bundle_steps-row');
                        stepsRow.setAttribute('activeSteps', _this._bundleVariables.currentQty);
                        var price = input.dataset.price;
                        priceWrapper.forEach(function (element) {
                            if (clearCart) {
                                _this._toggleLastStep(true);
                            } else {
                                _this._toggleLastStep(false);
                            }

                            element.innerHTML = _this._formatMoney(price, window.theme.strings.money_format_with_code_preference);
                        });
                        _this._progressBar();
                        _this._scrollTop();
                        _this._getQtyToUnlockStepOne();

                        const disable = false;
                        _this._lockProducts(disable);
                        _this._getActiveValue();
                        _this._setActiveDaysInfo();
                    });
                });
            }

            backOneStep.forEach((btn) => {
                btn.addEventListener('click', () => {
                    this._backOneStep();
                    this._updateAtcDisabling();
                    this._miniCartItemStep();
                })
            })

            const progressSteps = document.querySelectorAll('.bundle_progressbar-step');

            progressSteps.forEach((step) => {
                step.addEventListener('click', () => {
                    const activeStepValue = step.getAttribute('data-step')
                    document.querySelector(`.bundle_steps-item[data-step='${activeStepValue}'] h2`).click();
                    this._updateAtcDisabling();
                    this._miniCartItemStep();
                })
            })
        },

        _scrollTop() {
            const windowWidth = window.innerWidth;

            if (windowWidth < 768) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        },

        _getMinicartItemCol(collectionIDs) {
            const imgItems = document.querySelectorAll('.img_item');
            let matchCount = 0;

            imgItems.forEach((imgItem) => {
                const dataCollectionValue = imgItem.getAttribute('data-collection');

                if (dataCollectionValue) {
                    const dataValues = dataCollectionValue.split(',');

                    for (const dataValue of dataValues) {
                        if (collectionIDs.includes(Number(dataValue))) {
                            matchCount++;
                            break;
                        }
                    }
                }
            });

            return matchCount;
        },

        _backOneStep() {
            const activeStep = this._getCollectionIDs().dataStep;
            let activeValue = parseInt(activeStep);

            if (activeStep > '1') {
                if (activeStep === '2') {
                    document.querySelector('.js-backstab').classList.add("hidden");
                }
                activeValue--;
                document.querySelector(`.bundle_steps-item[data-step='${activeValue}'] h2`).click();
            }
        },

        _handleAddToBundleEvent: function ({ currentTarget }) {

            let buttonType = currentTarget.getAttribute("data-type");
            let productType = currentTarget.getAttribute("data-product-of");
            let productObject = JSON.parse(currentTarget.closest(Box_Builder._selectors.productItem).querySelector("script").innerHTML);

            switch (buttonType) {
                case "primary":
                    currentTarget.closest(".js-product-grid").classList.add("is-active");
                    Box_Builder._addProductToSlot("add", productObject, productType);
                    break;
                case "up":
                    Box_Builder._addProductToSlot("add", productObject, productType);
                    Box_Builder._updateQuantity(currentTarget, "up");
                    break;
                case "down":
                    Box_Builder._addProductToSlot("remove", productObject, productType);
                    Box_Builder._updateQuantity(currentTarget, "down");
                    break;
                default:
                    console.warn("Button type is missing");
                    break;
            }
        },

        _getCollectionIDs() {
            const activeStep = this._getActiveStep();
            const buttons = activeStep.querySelectorAll('.bundle-nav__item-btn');
            const collectionIDs = Array.from(buttons).map(button => parseInt(button.getAttribute('collection-id')));
            const dataStep = activeStep.getAttribute('data-step');

            return { collectionIDs, dataStep };
        },

        _addProductToSlot: function (operation, productObject, type) {
            if (operation === "add") {
                const collectionIDs = this._getCollectionIDs().collectionIDs;
                const activeStep = this._getCollectionIDs().dataStep;
                const existingProductCollectionIDs = this._bundleVariables.allProductsArray.map(product => product.collection_ids).flat();
                const commonValues = existingProductCollectionIDs.filter(value => collectionIDs.includes(value));
                const hasCommonValue = commonValues.length;
                const qtyToUnlock = this._getQtyToUnlockStepOne();

                let maxCap;
                if (activeStep === '1') {
                    maxCap = qtyToUnlock;
                } else {
                    maxCap = 1;
                }

                if (hasCommonValue < maxCap) {
                    this._bundleVariables.allProductsArray.push(productObject);
                    this._updateMiniCart(this._bundleVariables.allProductsArray, type, true);
                } else {
                    console.info("max cap")
                }

                maxCap--;

                if (hasCommonValue === maxCap) {
                    const disable = true;
                    this._lockProducts(disable);
                }
            }

            if (operation == "remove") {
                let reversedArray = this._bundleVariables.allProductsArray.reverse();
                let productHandle = productObject.handle;
                for (let i = 0; i < reversedArray.length; i++) {
                    if (reversedArray[i].handle === productHandle) {
                        reversedArray.splice(i, 1);
                        type === this._bundleVariables.allProductsArray.reverse();
                        break;
                    }
                }
                this._updateMiniCart(this._bundleVariables.allProductsArray, type, false);
            }

            this._updateAtcDisabling();
        },

        _lockProducts(disable) {
            const activeStep = this._getCollectionIDs().dataStep;
            const activeSummary = document.querySelectorAll('.left_product_wrap[data-step="' + activeStep + '"]');

            activeSummary.forEach((summary) => {
                const addToBundle = summary.querySelectorAll('.atc_btn.js-add-to-mini');

                addToBundle.forEach((btn) => {
                    if (disable) {
                        btn.setAttribute("disabled", "disabled");
                    } else {
                        btn.removeAttribute("disabled")
                    }
                })
            })
        },

        _setSinglePrice(wrapper) {
            const items = wrapper.querySelectorAll('.img_item[data-collection]')
            const activeStep = this._getActiveStep();
            const buttons = activeStep.querySelectorAll('.bundle-nav__item-btn');
            const collectionIDs = Array.from(buttons).map(button => parseInt(button.getAttribute('collection-id')));
            let matchingIDs = [];
            let price = 0;

            items.forEach(item => {
                const collections = item.dataset.collection.split(',').map(value => parseInt(value.trim()));
                const matchingValues = collections.filter(value => collectionIDs.includes(value));
                if (matchingValues.length > 0) {
                    matchingIDs.push(matchingValues.join(', '));
                }
            })

            const priceList = [
                { id: 397171622104, price: 4.5 }, //Juices
                { id: 390967263448, price: 4.5 }, //Soups
                { id: 615226999125, price: 2.5 }, // Shots
            ];

            matchingIDs.forEach(id => {
                const matchingItem = priceList.find(item => item.id === parseInt(id));
                if (matchingItem) {
                    price += matchingItem.price;
                } else {
                    price += 0;
                }
            });

            const qtyInput = document.querySelector('.qty-options input:checked');
            qtyInput.setAttribute('data-price', price*100)
            this._updateMiniCartPrice(price);
        },

        _updatePrice(price) {
            const atcPrice = document.querySelector('.js-price');
            atcPrice.textContent = '€' + price;
        },

        _getQtyValue() {
            const qty_val = document.querySelector("input[name='quantity']:checked").value;
            return qty_val;
        },

        _getActiveStep() {
            const active_step = document.querySelector('.bundle_steps-item[data-active="true"]');
            return active_step;
        },

        _getActiveValue() {
            const qtyOptions = [...document.querySelector('.qty-options').children];

            for (let i = 0; i < qtyOptions.length; i++) {
                const option = qtyOptions[i];
                const input = option.querySelector('input');

                if (input.checked) {
                    return i;
                }
            }

            return 0;
        },

        _getQtyToUnlockStepOne() {
            const enable_foodkur = this._bundleVariables.enable_foodkur;
            let qtyToUnlock = 6;
            const enable_singles = this._bundleVariables.enable_singles;

            if (enable_foodkur || enable_singles) {
                qtyToUnlock = this._getQtyValue();
            } else {
                qtyToUnlock = this._bundleVariables.qtyToUnlockAtc;
            }

            return qtyToUnlock;
        },

        _miniCartClass() {
            const bundleNavItems = document.querySelectorAll('.bundle_steps-item[data-active="false"] .bundle-nav__item-btn[data-active="false"]');
            const collectionIds = Array.from(bundleNavItems).map(item => item.getAttribute('collection-id'));
            const imgItems = document.querySelectorAll('.img_item');

            imgItems.forEach(item => item.classList.remove('inactive'));

            imgItems.forEach(item => {
                const dataCollection = item.getAttribute('data-collection');
                if (dataCollection) {
                    const dataCollectionValues = dataCollection.split(',');
                    if (dataCollectionValues.some(value => collectionIds.includes(value.trim()))) {
                        item.classList.add('inactive');
                    }
                }
            });
        },

        _miniCartItemStep() {
            const items = document.querySelectorAll('.img_item');
            const collectionIDs = this._getCollectionIDs().collectionIDs;
            const activeStep = this._getActiveStep().getAttribute('data-step');
            const qtyToUnlock = this._getQtyToUnlockStepOne();
            let count = 0;

            items.forEach((item => {
                const itemCol = item.getAttribute('data-collection');

                if (itemCol) {
                    const itemColValues = itemCol.match(/\d+/g).map(Number)
                    const existsInItemCol = collectionIDs.some(id => itemColValues.includes(id));
                    if (existsInItemCol) {
                        count++;
                        item.style.display = 'block';
                    } else {
                        item.style.display = 'none';
                    }
                }
            }))

            if (activeStep === '1') {
                count = qtyToUnlock - count;
            } else {
                count = 1 - count;
            }

            let displayCount = 0;

            items.forEach((item) => {
                const itemCol = item.getAttribute('data-collection');

                if (!itemCol) {
                    if (displayCount < count) {
                        item.style.display = 'block';
                        displayCount++;
                    } else {
                        item.style.display = 'none';
                    }


                }

                item.setAttribute('active-step', activeStep)
            });
        },

        _setStepStatus(newActiveStep) {
            let steps = document.querySelectorAll('.bundle_steps-item');

            steps.forEach((step) => {
                let buttons = step.querySelectorAll('button');
                let h2 = step.querySelector('h2');

                if (newActiveStep === h2) {
                    step.setAttribute('data-active', 'true');
                    buttons.forEach(function (button, index) {
                        if (index === 0) {
                            button.removeAttribute('disabled');
                            button.click();
                        } else {
                            button.removeAttribute('disabled');
                        }
                    });
                } else {
                    step.setAttribute('data-active', 'false');
                    buttons.forEach(function (button) {
                        button.setAttribute('disabled', 'disabled');
                    });
                }
            })
        },

        _toggleLastStep(clear) {
            const lastStep = document.querySelector(".bundle_steps-item[data-step='3']");
            const activeInput = this._getActiveValue();
            const max_steps = this._maxSteps;

            lastStep.style.display = "none";

            if (activeInput !== 0 && max_steps === 3) {
                lastStep.style.display = "flex";
            }

            // Reset Box Builder
            const firstStep = document.querySelector(".bundle_steps-item[data-step='1'] h2");
            firstStep.click();
            this._clearCart(clear);
            setTimeout(() => {
                this._updateAtcDisabling();
            }, 100);
        },

        _swapStepTitle() {
            const h2Elements = document.querySelectorAll('.bundle_steps-item h2');
            h2Elements.forEach(function (h2) {
                h2.addEventListener('click', function (event) {
                    this._setStepStatus(event.target);
                    this._progressBar();
                    this._miniCartClass();
                    this._setBtnText();
                    this._setPaymentMethods();
                }.bind(this));
            }.bind(this));
        },

        _progressBar() {
            const activeStep = this._getCollectionIDs().dataStep;

            const barStep = document.querySelectorAll('.bundle_progressbar-step');
            const progressBar = document.querySelector('.bundle_progressbar-bar');
            const progressWrapper = document.querySelector('.bundle_progressbar');
            const days = this._getQtyValue();
            const max_steps = this._maxSteps;

            if (max_steps === 2) {
                progressBar.classList.add('progress_bar_two_steps');
            }

            progressWrapper.setAttribute('data-days', days);

            progressBar.setAttribute('data-step', activeStep);

            barStep.forEach((step) => {
                step.setAttribute('data-active', false);

                if (step.getAttribute('data-step') <= activeStep) {
                    step.setAttribute('data-active', true);
                }
            })

            if (activeStep > 1) {
                document.querySelector('.js-backstab').classList.remove("hidden");
            } else {
                document.querySelector('.js-backstab').classList.add("hidden");
            }
        },

        // sets the amount of items in the minicart
        _miniCartItems() {
            let qty = parseInt(this._getQtyToUnlockStepOne());
            let inputBtn = this._getQtyValue();

            qty++

            if (inputBtn >= '5') {
                qty++;
            }

            return qty;
        },

        _updateMiniCart: function (array, type, itemAdded) {
            const minCartClass = document.querySelector('.js-mini-cart-items');
            const qtyInputVal = this._miniCartItems();

            let _this = this;
            let groupArray = array;
            let groupHtml = "";
            minCartClass.innerHTML = "";

            for (let i = 0; i < qtyInputVal; i++) {
                if (groupArray[i] != undefined) {
                    let ids = groupArray[i].collection_ids;

                    const src = groupArray[i].media[0].src
                    const srcReduced = src.replace(/(\.\w+)(\?v=\d+)$/, "_100x100$1$2");

                    groupHtml = this._getItemHtml();
                    let stringsToReplaceWith = {
                        "ProductIndex": i,
                        "ProductType": type,
                        "ProductHandle": groupArray[i].handle,
                        "ProductImage": srcReduced,
                        "Collections": [...ids]
                    };
                    groupHtml = groupHtml.replace(/\b(?:ProductIndex|ProductType|ProductHandle|ProductImage|Collections)\b/gi, matched => stringsToReplaceWith[matched]);
                    minCartClass.innerHTML += groupHtml;

                    if (itemAdded) {
                        if (minCartClass.querySelectorAll(".product_img")[groupArray.length - 1] != minCartClass.querySelectorAll(".product_img")[i]) {
                            minCartClass.querySelectorAll(".product_img")[i].classList.remove("hide");
                            minCartClass.querySelectorAll(".svg_wrap")[i].querySelector("svg").classList.add("hide");
                        }
                        setTimeout(function () {
                            if (minCartClass.querySelectorAll(".product_img")[groupArray.length - 1]) {
                                minCartClass.querySelectorAll(".product_img")[groupArray.length - 1].classList.remove("hide");
                                minCartClass.querySelectorAll(".svg_wrap")[groupArray.length - 1].querySelector("svg").classList.add("hide");
                            }
                        }, 0);

                    } else {
                        minCartClass.querySelectorAll(".product_img")[i].classList.remove("hide");
                        minCartClass.querySelectorAll(".svg_wrap")[i].querySelector("svg").classList.add("hide");
                    }
                } else {
                    minCartClass.innerHTML += this._getEmptyItemHtml();
                }
            }

            this._miniCartClass();

            document.querySelectorAll(this._selectors.removeItemFromBundle).forEach((removeBtn) => {
                removeBtn.classList.add("evt-bind");
                removeBtn.addEventListener("click", _this._handleRemoveEvent.bind(this));
            });

            this._miniCartItemStep()

            const enable_singles = this._bundleVariables.enable_singles;
            if (enable_singles) {
                this._setSinglePrice(minCartClass);
            }
        },

        _updateMiniCartPrice: function () {
            let _this = this;
            let allGroupArray = this._bundleVariables.allProductsArray;
            let totalProductCount = allGroupArray.length;
            let totalRawPrice = 0;
            let discountPrice = 0;
            let discountAmount;
            for (let item of allGroupArray) {
                totalRawPrice += item.raw_price;
            }

            const _highestDiscountLimiter = Math.max(..._this._bundleVariables.discountLimiter);
            const _lowestDiscountLimiter = Math.min(..._this._bundleVariables.discountLimiter);

            if (totalProductCount > _highestDiscountLimiter) {
                discountAmount = Object.values(_this._bundleVariables.discountRules).pop();
            } else if (totalProductCount <= _highestDiscountLimiter && totalProductCount >= _lowestDiscountLimiter) {
                discountAmount = _this._bundleVariables.discountRules[totalProductCount];
            } else {
                discountAmount = 0;
            }

            discountPrice = (1 - discountAmount / 100) * totalRawPrice;

            document.querySelectorAll(this._selectors.priceSelector).forEach(function (element) {
                element.innerHTML = _this._formatMoney(discountPrice, window.theme.strings.money_format_with_code_preference);
            });

            document.querySelectorAll(this._selectors.compareAtPriceSelector).forEach(function (element) {
                if (totalRawPrice === discountPrice) {
                    element.classList.add("hide");
                } else {
                    element.innerHTML = _this._formatMoney(totalRawPrice, window.theme.strings.money_format_with_code_preference);
                    element.classList.remove("hide");
                }
            });
        },

        _updateButtonStates: function () {
            let allAddButtons = document.querySelectorAll(`${this._selectors.addToBundle}:not([data-type='down'])`);
            let totalCount = this._bundleVariables.allProductsArray.length;

            if (totalCount < this._miniCartItems()) {
                allAddButtons.forEach((addToMiniCartBtn) => {
                    addToMiniCartBtn.removeAttribute("disabled");
                });
            } else {
                allAddButtons.forEach((addToMiniCartBtn) => {
                    addToMiniCartBtn.setAttribute("disabled", "disabled");
                });
            }
        },

        _updateQuantity: function (button, type) {
            let quantityInput = button.closest("quantity-selector").querySelector("input");
            let quantityInputValue = parseInt(quantityInput.value);
            let buttonContainer = button.closest(this._selectors.productItem); // The container has all information such as product, type, etc
            if (type !== "up" && quantityInputValue == 1) {
                buttonContainer.classList.remove("is-active");
            }
        },

        _getStepCollections() {
            const bundleItems = document.querySelectorAll('.bundle_steps-item');
            const resultArray = [];

            bundleItems.forEach((bundleItem) => {
                const dataStep = bundleItem.getAttribute('data-step');
                const buttons = bundleItem.querySelectorAll('.bundle-nav__item-btn');
                const collectionIds = Array.from(buttons).map((button) => button.getAttribute('collection-id'));
                const stepObject = {
                    "data-step": dataStep,
                    "collection-ids": collectionIds,
                };

                resultArray.push(stepObject);
            });

            return resultArray;
        },

        _setActiveDaysInfo() {
            const qtyValue = this._getQtyValue();
            const infoTexts = document.querySelectorAll('.ed-days__info');

            if (infoTexts) {
                infoTexts.forEach(info => {
                    const infoValue = info.getAttribute('data-days');

                    if (infoValue === qtyValue) {
                        info.setAttribute('data-active', true)
                    }
                    else {
                        info.setAttribute('data-active', false)
                    }
                })
            }
        },

        _setPaymentMethods() {
            const qtyValue = this._getQtyValue();
            const activeStep = parseInt(this._getCollectionIDs().dataStep);
            const paymentMethods = document.querySelector('.ed-payment-methods')

            if (paymentMethods) {
                if (activeStep === 3 && qtyValue >= '5' || activeStep === 2 && qtyValue <= '4') {
                    paymentMethods.classList.add('visible')
                } else {
                    paymentMethods.classList.remove('visible')
                }
            }
        },

        _getBundleMainProduct(qty) {
            const bundleJSON = JSON.parse(document.querySelector("#mixnmatchVariables").innerHTML);

            if (qty) {
                const matchedBlock = bundleJSON.qty_blocks.find(block => block.days === qty);

                if (matchedBlock) {
                    return matchedBlock.product[0].id;
                } else {
                    console.warn(`No matching qty_block found for days = ${qty}`);
                    return null;
                }
            }

            console.warn('Qty is not provided');
            return null;
        },

        _handleAddToCartEvent: function () {
            let groupArray = this._bundleVariables.allProductsArray;
            let uniqueBundleId = (Date.now()).toString();
            let items = [];

            const qtyInput = document.querySelector('.qty-options input:checked');
            const qty = qtyInput ? +qtyInput.value : 1;
            const currQty = this._bundleVariables.currentQty;
            const enable_singles = this._bundleVariables.enable_singles;
            const bundleProductId = this._getBundleMainProduct(parseInt(currQty))
            let bundlePrice = parseFloat(qtyInput.getAttribute('data-price'));

            let variantSet = new Set();
            for (let item of groupArray) {
                const variantObject = {
                    "variant-id": item["variant-id"],
                    "collection_ids": item.collection_ids,
                    "tags": item.tags
                };

                variantSet.add(variantObject);
            }

            let variantIds = [...variantSet];
            for (let variantId of variantIds) {
                let tempObject = {};
                tempObject.id = variantId["variant-id"];
                tempObject.collection_ids = variantId["collection_ids"];
                tempObject.tags = variantId["tags"];
                let productInBoxQty = 0;

                for (let item of groupArray) {
                    if (variantId["variant-id"] === item["variant-id"]) {
                        productInBoxQty++;
                    }
                }

                const stepCollections = this._getStepCollections();
                let dataStep, currentCol;

                const tempCollectionSet = new Set(tempObject.collection_ids.map(id => id.toString()));

                for (const step of stepCollections) {
                    const stepCollectionSet = new Set(step['collection-ids'].map(id => id.toString()));

                    for (const collectionId of tempCollectionSet) {
                        if (stepCollectionSet.has(collectionId)) {
                            dataStep = step['data-step'];
                            currentCol = collectionId;
                        }
                    }
                }

                const pfandTagFound = tempObject.tags.some(tag => tag.startsWith('pfand'));
                // tempObject.properties = { _bundleID: uniqueBundleId, _cureType: currQty, _boxBuilder: true, _pfand: "false", _foodkur: this._bundleVariables.enable_foodkur, _singles: 0, _singlesBuilder: "false" }
                tempObject.properties = { _edBundleId: uniqueBundleId, _edBundleMasterId: bundleProductId, _edBundlePrice: bundlePrice, _edUpsellToken: this._bundleVariables.upsell_token, _edHash: this._bundleVariables.hash, _edPfand: pfandTagFound}

                // only activate pfand on juices
                if (currentCol === '397171622104') {
                    // tempObject.properties._pfand = "true";
                }

                if (!enable_singles) {
                    if (dataStep === '3') {
                        tempObject.quantity = 1;
                    } else {
                        if (currentCol === '612052042069') {
                            tempObject.quantity = productInBoxQty;
                        }
                        else {
                            tempObject.quantity = productInBoxQty > 0 ? qty * productInBoxQty : qty;
                        }
                    }
                } else {
                    tempObject.quantity = productInBoxQty;
                    // tempObject.properties._singlesBuilder = true;
                    const matchingPrice = this._bundleVariables.prices.find(price => price.collection_id.toString() === currentCol);

                    if (matchingPrice) {
                        const priceElement = document.querySelector('.js-price-compare');
                        const priceText = priceElement.textContent.trim().replace(/[^\d]/g, '');
                        const priceAsInteger = parseInt(priceText, 10);
                        bundlePrice = priceAsInteger;
                        // tempObject.properties._singles = matchingPrice.price;
                    }
                }

                items.push(tempObject);
            }

            let itemsObject = { items: items };
            const activeInput = this._getActiveValue();
            let qtyToUnlockAtc = parseInt(this._getQtyToUnlockStepOne()) + 1;

            if (!enable_singles) {
                if (activeInput >= 1 && this._maxSteps === 3) {
                    qtyToUnlockAtc++
                }

                if (activeInput === 2) {
                    let variableJSON = JSON.parse(document.querySelector("#freeProduct").innerHTML);
                    const newItem = {
                        id: variableJSON.id,
                        collection_ids: variableJSON.collection_id,
                        quantity: 1,
                        properties: {
                            _edBundleId: uniqueBundleId,
                            _edBundleMasterId: bundleProductId,
                            _edBundlePrice: bundlePrice
                        }
                    };

                    if (newItem.id) {
                        itemsObject.items.push(newItem);
                    }
                }
            } else {
                qtyToUnlockAtc--;
            }

            if (groupArray.length !== qtyToUnlockAtc) {
                return;
            }

            // add free gift if value is cleared
            const freeGifts = this._bundleVariables.free_gifts;

            freeGifts.forEach(gift => {
                const freeItem = {
                    id: gift.product_id,
                    quantity: 1,
                    properties: {
                        _bundleID: uniqueBundleId,
                        _cureType: currQty,
                        _boxBuilder: true,
                        _pfand: "false",
                        _foodkur: this._bundleVariables.enable_foodkur,
                        _singles: 0,
                        _singlesBuilder: "false"
                    }
                };
            
                let cartTotalValue = document.querySelector(this._selectors.priceSelector).textContent;
                if (!cartTotalValue) {
                    cartTotalValue = document.querySelector(this._selectors.compareAtPriceSelector).textContent;
                }
                cartTotalValue = parseFloat(cartTotalValue.replace('€', '').replace(',', '.')) * 100;

                if (cartTotalValue >= (gift.min_value)) {
                    itemsObject.items.push(freeItem);
                }
            });

            function removeDuplicates(arr) {
                const uniqueIds = new Set();
                return arr.filter(item => {
                    if (!uniqueIds.has(item.id)) {
                        uniqueIds.add(item.id);
                        return true;
                    }
                    return false;
                });
            }

            itemsObject.items = removeDuplicates(itemsObject.items);

            // calculate pfand and add canteen pfand item
            // product needs tag that contains pfand to be considered
            let pfand_items = 0;

            itemsObject.items.forEach(item => {
                if (item.properties._edPfand) {
                    pfand_items += item.quantity;
                }
            })

            if (pfand_items > 0) {
                let variableJSON = JSON.parse(document.querySelector("#pfandProduct").innerHTML);
                let variants = variableJSON.products[0].variants;
                let closestMatch = null;
                let closestMatchValue = -Infinity;
            
                variants.forEach(variant => {
                    // Extract the number before the 'x' in the title (e.g., '30x 25 Cent' -> 30)
                    let match = variant.title.match(/^(\d+)x/);
                    if (match) {
                        let amount = parseInt(match[1]);
                        if (amount <= pfand_items && amount > closestMatchValue) {
                            closestMatchValue = amount;
                            closestMatch = variant;
                        }
                    }
                });
            
                // Check if a match was found
                if (closestMatch) {
                    // Create a new item object
                    const newItem = {
                        id: closestMatch.id,
                        quantity: 1,
                        // When propeties match the Pfand product will be bundles
                        properties: {
                            _edBundleId: uniqueBundleId,
                            _edBundleMasterId: bundleProductId,
                            _edBundlePrice: bundlePrice,
                            _edUpsellToken: this._bundleVariables.upsell_token,
                            _edHash: this._bundleVariables.hash,
                            _edPfand: false
                        }
                    };
            
                    // Add the new item to the itemsObject array
                    itemsObject.items.push(newItem);
                    bundlePrice += pfand_items*25;
                } else {
                    console.error("No suitable variant found.");
                }
            }

            // Generate new final item for bundle v2
            const itemsArray = itemsObject.items;
            const edBundleItems = itemsArray.flatMap(item => Array(item.quantity).fill(item.id)).join(',');
            const finalItem = {
                id: bundleProductId,
                quantity: 1,
                properties: {
                    _edBundleId: uniqueBundleId,
                    _edBundlePrice: bundlePrice.toString(),
                    _edUpsellToken: this._bundleVariables.upsell_token,
                    _edHash: this._bundleVariables.hash,
                    _edPfand: false,
                    _edBundleItems: edBundleItems
                }
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(finalItem)
            })
                .then(response => {
                    return response.json();
                }).then(json => {
                    document.dispatchEvent(new Event("ajaxProduct:added"));
                    document.dispatchEvent(new Event("cart:build"));
                    document.dispatchEvent(new Event("cart:open"));
                })
                .catch((error) => {
                    console.error('Error:', error);
                })
        },

        _handleRemoveEvent: function (e) {
            let buttonIndex = e.currentTarget.dataset.index;
            let buttonType = e.currentTarget.dataset.type;
            let buttonHandle = e.currentTarget.dataset.handle; // We remove the item by index
            let array = this._bundleVariables.allProductsArray;

            this._removeFromBundleEvent(buttonIndex, buttonType, buttonHandle);
            this._updateMiniCart(array, buttonType);

            const disable = false;
            this._lockProducts(disable);
        },

        _clearCart(clear) {
            if (clear) {
                this._bundleVariables.allProductsArray = [];
            }
            this._updateMiniCart(this._bundleVariables.allProductsArray, undefined);
            this._updateAtcDisabling();
        },

        _removeFromBundleEvent: function (index, type, productHandle) {

            let productQuantityInput = document.querySelector(`.js-product-grid[data-handle='${productHandle}'] quantity-selector input`);
            let productQuantityValue = parseInt(productQuantityInput.value);
            let buttonContainer = productQuantityInput.closest(this._selectors.productItem); // The container has all information such as product, type, etc
            // We change the quantity input of associated product

            if (productQuantityValue > 1) {
                productQuantityInput.value = productQuantityValue - 1;
            }

            this._bundleVariables.allProductsArray.splice(index, 1);

            setTimeout(() => {
                this._updateAtcDisabling();
            }, 100);
        },

        _getItemHtml: function () {
            return `
            <div class="img_item" data-collection="Collections">
                <div class="product_img hide">
                    <img width="100" height="100" loading="lazy" src="ProductImage" />
                </div>
                <div class="svg_wrap">
                    ${window.mixnmatch.svgs.sleep}
                </div>
                <div class="remove_icon">
                    <button type="button" class="js-remove-item" data-index="ProductIndex" data-type="ProductType" data-handle="ProductHandle">
                        ${window.mixnmatch.svgs.remove}
                    </button>
                </div>
            </div>
            `;
        },

        _getEmptyItemHtml: function () {
            return `
            <div class="img_item">
                <div class="svg_wrap">
                    ${window.mixnmatch.svgs.sleep}
                </div>
            </div>
            `;
        },

        _formatMoney: function (t, r) {
            function e(t, r) {
                return void 0 === t ? r : t;
            }

            function a(t, r, a, o) {
                if (r = e(r, 2), a = e(a, ","), o = e(o, "."), isNaN(t) || null == t) return 0;
                t = (t / 100).toFixed(r);
                var n = t.split(".");
                return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? o + n[1] : "");
            }

            "string" == typeof t && (t = t.replace(".", ""));
            var o = "",
                n = /\{\{\s*(\w+)\s*\}\}/,
                i = r || this.money_format;

            switch (i.match(n)[1]) {
                case "amount":
                    o = a(t, 2);
                    break;

                case "amount_no_decimals":
                    o = a(t, 0);
                    break;

                case "amount_with_comma_separator":
                    o = a(t, 2, ".", ",");
                    break;

                case "amount_with_space_separator":
                    o = a(t, 2, " ", ",");
                    break;

                case "amount_with_period_and_space_separator":
                    o = a(t, 2, " ", ".");
                    break;

                case "amount_no_decimals_with_comma_separator":
                    o = a(t, 0, ".", ",");
                    break;

                case "amount_no_decimals_with_space_separator":
                    o = a(t, 0, " ", "");
                    break;

                case "amount_with_apostrophe_separator":
                    o = a(t, 2, "'", ".");
                    break;

                case "amount_with_decimal_separator":
                    o = a(t, 2, ".", ".");
            }

            return i.replace(n, o);
        },
    };
    Box_Builder._init();
})();
            console.log("🚀 ~ itemsArray:", itemsArray)
            console.log("🚀 ~ itemsArray:", itemsArray)
            console.log("🚀 ~ itemsArray:", itemsArray)
            console.log("🚀 ~ itemsArray:", itemsArray)
